import { Injectable } from "@angular/core";

import { RegistrationFeatureState } from "../../state";

import { DgaRegistrationFormData, DgaRegistrationState } from "./dga-registration.model";

@Injectable({
	providedIn: "root",
})
export class DgaRegistrationSelector {
	getState() {
		return (state: RegistrationFeatureState): DgaRegistrationState => state.registrationFeature.dgaRegistration;
	}

	getRegistrationFormData() {
		return (state: RegistrationFeatureState): DgaRegistrationFormData | undefined =>
			state.registrationFeature.dgaRegistration.registrationFormData;
	}

	isBusy() {
		return (state: RegistrationFeatureState): boolean => state.registrationFeature.dgaRegistration.isBusy;
	}
}
